<template lang="pug">
.table-responsive
    table.table
        thead
            tr
                th.text-nowrap.w-md Outlet
                th.text-nowrap.w-sm(v-show="product.use_variant") Variant
                th.text-nowrap Quantity
                th.text-nowrap Low Stock Qty
                th.text-nowrap Ideal Stock Qty
        tbody
            template(v-for="outlet in allowedOutletList")
                tr(v-for="(v, v_index) in variants", :key="`stock_${product.id}_${outlet.id}_${v.id}`")
                    td(:rowspan="variants.length", v-if="v_index == 0") {{ outlet.name }}
                    td(v-show="product.use_variant")
                        span {{ v.name }}
                    
                    td
                        input.form-control.min-100(
                            :key="`quantity_${product.id}_${outlet.id}_${v.id}`",
                            :class="{ 'has-error': errors.has('quantity', `${outlet.id}_${v.id}`) }",
                            :data-vv-scope="`${outlet.id}_${v.id}`",
                            :value="geOutletStock(outlet.id, v.id).quantity"
                            v-validate="'required|decimal:2|min_value:0'",
                            name="quantity",
                            type="text",
                            placeholder="0.00",
                            @input="updateOutletInventory(outlet.id, v.id, 'quantity', $event.target.value)",
                        )
                        span.text-danger(v-if="errors.has('quantity', `${outlet.id}_${v.id}`)")
                            | {{ errors.first('quantity', `${outlet.id}_${v.id}`) }}

                    td
                        input.form-control.min-100(
                            :key="`low_${product.id}_${outlet.id}_${v.id}`",
                            :class="{ 'has-error': errors.has('low stock level', `${outlet.id}_${v.id}`) }",
                            :data-vv-scope="`${outlet.id}_${v.id}`",
                            v-validate="'decimal:2|min_value:0'",
                            name="low stock level",
                            :value="geOutletStock(outlet.id, v.id).low_stock_level",
                            type="text",
                            placeholder="0.00",
                            @input="updateOutletInventory(outlet.id, v.id, 'low_stock_level', $event.target.value)",
                        )
                        span.text-danger(v-if="errors.has('low stock level', `${outlet.id}_${v.id}`)")
                            | {{ errors.first('low stock level', `${outlet.id}_${v.id}`) }}

                    td
                        input.form-control.min-100(
                            :key="`ideal_${product.id}_${outlet.id}_${v.id}`",
                            :class="{ 'has-error': errors.has('ideal stock level', `${outlet.id}_${v.id}`) }",
                            :data-vv-scope="`${outlet.id}_${v.id}`",
                            v-validate="'decimal:2|min_value:0'",
                            name="ideal stock level",
                            :value="geOutletStock(outlet.id, v.id).ideal_stock_level"
                            type="text",
                            placeholder="0.00",
                            @input="updateOutletInventory(outlet.id, v.id, 'ideal_stock_level', $event.target.value)",
                        )
                        span.text-danger(v-if="errors.has('ideal stock level', `${outlet.id}_${v.id}`)")
                            | {{ errors.first('ideal stock level', `${outlet.id}_${v.id}`) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['$validator'],

    computed: {
        ...mapGetters('outlet', ['allowedOutletList']),
        ...mapGetters('product', [
            'variants',
            'product',
            'findOutletInventory',
            'findOutletInventoryIndex',
            'findVariantIndex',
        ]),
    },

    methods: {
        ...mapActions('product', ['setOutletInventoryAttr']),

        geOutletStock(outlet_id, variant_id) {
            if (!this.findOutletInventory(outlet_id, variant_id)) {
                this.setOutletInventoryAttr({
                    outlet_id,
                    variant_id,
                    key: 'quantity',
                    value: 0,
                });
            }

            return this.findOutletInventory(outlet_id, variant_id);
        },

        updateOutletInventory(outlet_id, variant_id, key, value) {
            this.setOutletInventoryAttr({ outlet_id, variant_id, key, value });
        },

        /**
         * To macth field name error return by laravel
         **/
        variantValidatorScope(outlet_id, variant_id, key) {
            return `stock_${outlet_id}_${variant_id}.${key}`;
        },

        hasError(oid, vid, field) {
            const scope = this.variantValidatorScope(oid, vid, field);
            return this.errors.all(scope).length > 0;
        },

        firstError(oid, vid, field) {
            const scope = this.variantValidatorScope(oid, vid, field);

            if (this.hasError(oid, vid, field))
                return this.errors.all(scope)[0];

            return null;
        },
    },
};
</script>

<style lang="scss" scoped>
.min-width-200 {
    min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-stock-inventory.vue